import { component } from 'picoapp'
import { subscribe } from 'klaviyo-subscribe'

export default component((node) => {
    const submitBtn = node.querySelector('[data-submit]')
    const email = node.querySelector('[data-email]')
    const status = node.querySelector('[data-status]')
    const listId = window.theme.klaviyo_id

    submitBtn.addEventListener('click', () => {
        if (!email.checkValidity() || listId == null) return
        subscribe(listId, email.value, {}).then(() => {
            if (window.raptor) {
                window.raptor.push('setRuid', email.value)
            }
            submitBtn.innerHTML = window.newsletterSection.submitBtnSuccess
            status.innerHTML = window.newsletterSection.submitSuccessMsg
        })
    })
})
